import AwardWinnerResults from './AwardWinnerResults';
import LocationTally from './LocationTally';

class AwardsWinnerData {
  results = [];

  totals = null;

  constructor(data = [], totals = {}, awardNames = []) {
    this.results = AwardWinnerResults.fromList(data);
    this.totals = LocationTally.fromObject(totals).setTally(totals);
  }
}

export default AwardsWinnerData;
